import axios from 'axios';
import Phone from '../../_common/scripts/phone.js';
import Shortlist from '../../_common/scripts/shortlist.js';
import ShortlistNew from '../../_common/scripts/shortlist-new.js';
import Lazy from '../../_common/scripts/lazy.js';

export default class Pagination {

  init($) {
    this.api = axios.create({
      baseURL: process.env.NODE_ENV === 'test' ? 'http://hip.test/' : '/'
    });

    $('body').on('click', '.pagination__link-next', (e) => {
      e.preventDefault();
      const link = $(e.target);
      const url = link.attr('href');
      const pagination = link.closest('.pagination');

      link.replaceWith('<div class="loader">' +
        '<div class="sk-three-bounce">' +
        '<div class="sk-bounce1"></div><div class="sk-bounce2"></div><div class="sk-bounce3"></div>' +
        '</div></div>');

      this.getNextPage(url)
        .then((result) => {
          pagination.replaceWith(result.data);

          Lazy.refresh();

          (new ShortlistNew()).init($);
          (new Shortlist()).init($);
          (new Phone()).init($);
        });
    });
  }

  getNextPage(url) {
    return this.api.get(url, { params: { style: 'no_branding', suppressHeaders: true } });
  }

}



// WEBPACK FOOTER //
// ./_common/scripts/pagination.js